var map = {
	"./dislike-hand.png": "8271",
	"./exclamation.png": "8620",
	"./flag.png": "41e4",
	"./generic-event.png": "1825",
	"./like-hand.png": "9f5c",
	"./movie-clapper.png": "e5de",
	"./pause.png": "bda5",
	"./picture.png": "af78",
	"./play.png": "6ad8",
	"./speech-bubble.png": "62b0",
	"./stop.png": "8f10",
	"./surveillance-camera.png": "e29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3468";